module.exports = self.DOMPurify || (self.DOMPurify = require('dompurify').default || require('dompurify'));
